import { useContext } from "react";
import { Context } from "../../../Store/Store";
import { NavLink } from "react-router-dom";

import Styles from "./Nav.module.css";
import { Button, styled } from "@mui/material";

import { IoOptions} from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import { HiOutlineViewGrid } from "react-icons/hi";
import { MdGroups, MdExtension } from "react-icons/md";
import { LuHeadphones } from "react-icons/lu";
import { BiSolidMessageDetail } from "react-icons/bi";
import { mixpanelEvent } from "../../../Utils/mixpanelUtils";
import { LINKS } from "../../../Utils/constants";

const styles = {
  Nav: {
    display: "flex",
    flexDirection: "column",
    height: " 100%",
    gap: "5px",
    padding: 0,
    margin: 0,
  },
  SocialMediaBox: {
    display: "flex",
    alignItems: "center",
    gap: ".8rem",
    marginTop: "5px",
    padding: "0 0 0 12px",
  },
  SocialMedia: {
    background: "white",
    height: "26px",
    width: "26px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  SocialMediaIcon: {
    height: "18px",
    width: "18px",
    color: "#2f3eac",
  },

  UpgradeBtn: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    backgroundColor: "white",
    color: "var(--color-primary)",
    borderRadius: "10px",
    fontWeight: "600",
    fontFamily: "poppins",
    lineHeight: "20px",
    textTransform: "none",
    margin: "0 0 0 12px",
    padding: "8px 24px",
    textDecoration: "none",
    "&:hover": {
      background: "white",
      color: "var(--color-primary)",
      textDecoration: "none",
    },
  },
  ProIcon: {
    height: "18px",
    width: "18px",
  },
};

const StyledNavLink = styled(NavLink)(({ theme }) => ({
  "&:link, &:visited": {
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    gap: "12px",
    color: "white",
    fontSize: "16px",
    fontWeight: "600",
    padding: "6px 12px",
    transition: "all 0.3s",
    textDecoration: "none",
  },

  "&:hover, &:active, &.active:link, &.active:visited": {
    color: "var(--color-primary)",
    backgroundColor: "white",
    borderRadius: "10px",
    textDecoration: "none",
  },
  "& svg": {
    width: "24px",
    height: "24px",
    color: "white",
    transition: "all 0.3s",
  },
  "&:hover svg, &:active svg, &.active:link svg, &.active:visited svg": {
    color: "var(--color-primary)",
  },
}));

function Nav() {
  const context = useContext(Context);
  const state = context[0];
  const premiumUser =
    state.user?.data?.group === "Premium" ||
    state.user?.data?.group === "Growth Plan" ||
    state.user?.data?.group === "Member" ||
    state.user?.data?.group === "Starter" ||
    state.user?.data?.group === "Trial";
  return (
    <ul style={styles.Nav}>
      <li>
        <StyledNavLink to="/Home">
          <HiOutlineViewGrid />
          <span>Sales Insights</span>
        </StyledNavLink>
      </li>
      <li
        onClick={() => {
          mixpanelEvent("left_navigation_clicked", {
            navigation_item: "Monitor",
            navigation_position: "header",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <StyledNavLink to="/NurtureProspects">
          <MdGroups />
          <span>Customer Feed</span>
        </StyledNavLink>
      </li>
      <li
        onClick={() => {
          mixpanelEvent("left_navigation_clicked", {
            navigation_item: "Customize AI",
            navigation_position: "header",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <StyledNavLink to="/CustomizeAI">
          <IoOptions style={{ transform: "rotateY(180deg)", strokeWidth: "20px" }} />
          <span>Customize AI</span>
        </StyledNavLink>
      </li>
      <li
        onClick={() => {
          mixpanelEvent("left_navigation_clicked", {
            navigation_item: "Integrations",
            navigation_position: "header",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <StyledNavLink to="/Integrations">
          <MdExtension />
          <span>Integrations</span>
        </StyledNavLink>
      </li>
      {!premiumUser && (
        <li>
          <a style={{ display: "inline-block" }} href="/Billing" rel="noreferrer">
            <Button
              sx={styles.UpgradeBtn}
              variant="contained"
              onClick={() => {
              mixpanelEvent("upgrade_to_pro_clicked", {
                button_text: "Upgrade to Pro",
                page_section: "Sidebar",
                screen_name: "Engagment community and software",
              });
            }}
            >
              <img style={styles.ProIcon} src="/images/crown.svg" alt="pro icon" />
              <span>Upgrade to Pro</span>
            </Button>
          </a>
        </li>
      )}
      <li
        style={{ marginTop: "auto" }}
        onClick={() => {
          mixpanelEvent("support_link_clicked", {
            link_name: "Help & Strategy Hub",
            link_section: "sidebar",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <a
          href={LINKS.HELP_CENTER}
          target="_blank"
          rel="noreferrer"
          className={Styles.AnchorLink}
        >
          <LuHeadphones />
          <span>Help & Strategy Hub</span>
        </a>
      </li>
      <li
        onClick={() => {
          mixpanelEvent("support_link_clicked", {
            link_name: "Contact Us",
            link_section: "sidebar",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <a
          href="https://tally.so/r/mDkRyN"
          target="_blank"
          rel="noreferrer"
          className={Styles.AnchorLink}
        >
          <FaPhoneAlt />
          <span>Contact Us</span>
        </a>
      </li>
      <li
        onClick={() => {
          mixpanelEvent("support_link_clicked", {
            link_name: "Feedback",
            link_section: "sidebar",
            screen_name: "Engagment community and software",
          });
        }}
      >
        <StyledNavLink to="/Feedback">
          <BiSolidMessageDetail />
          <span>Feedback</span>
        </StyledNavLink>
      </li>
    </ul>
  );
}

export default Nav;
